module.exports = __webpack_public_path__ + "static/media/angular-js.dd68dea5.png";